<script>
import { HISTORIC_HEADER } from '@/store/mutation-types'

export default {
  name: 'ZTable',
  props: {
    defaultHeader: {
      type: Array,
      required: false,
      default: () => []
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    total: {
      type: Number,
      default: undefined,
    },
    currentPage: {
      type: Number,
      default: undefined,
    },
    isShowSort: {
      type: Boolean,
      default: false,
    },
    isShowSelection: {
      type: Boolean,
      default: false,
    },
    isShowPageSearch: {
      type: Boolean,
      default: false,
    },
    // 是否启用本地表头 TIPS：启用本地表头可以在刷新页面时保持上次离开时选择显示的表头，禁用则默认显示全部
    useLocalHeader: {
      type: Boolean,
      default: false // 默认禁用
    }
  },
  data () {
    return {
      avaliableHeader: [],
      avaliableProps: [],
      selectedHeader: [],
      isShowTable: true,

      isShowSearch: false,
      searchString: '',

      sortHeader: [],
      sortType: 'ascending',

      lastTableData: [],
      lastPage: 1,
    }
  },
  computed: {
    isShowPagination () {
      return this.total != null && this.currentPage != null
    }
  },
  watch: {
    /**
     * FIXME: 当prop更新后，执行render时，Table.componentInstance 为 undefined
     * 需要重新更新，先记录就状态，然后到updated的时候强制更新
    */
    currentPage (newVal, oldValue) {
      this.lastPage = oldValue
    }
  },
  methods: {
    initHeader () {
      const pageKey = this.$route.path + (this.$route.query.tab || '')
      let historicHeader
      // 通过useLocalHeader控制是否使用本地表头，在每次刷新时根据本地表头进行渲染
      if (this.useLocalHeader) {
        historicHeader = this.$ls.get(HISTORIC_HEADER) && this.$ls.get(HISTORIC_HEADER)[pageKey]
      }
      const selectedHeader =
        historicHeader ||
        (this.defaultHeader.length > 0 && this.defaultHeader) ||
        this.avaliableHeader

      this.updateTable(selectedHeader)
    },
    onCheckBoxChange (item, selectedIndex, selected) {
      const selectedHeader = [...this.selectedHeader]
      if (selected) {
        selectedHeader[selectedIndex] = item
        this.updateTable(selectedHeader)
      } else {
        const random = Math.random().toFixed(4).slice(2)
        selectedHeader[selectedIndex] = random
        this.updateTable(selectedHeader)
      }
    },
    /**
     * 更新 表头
    */
    updateHeader (header) {
      const historicHeader = this.$ls.get(HISTORIC_HEADER)
      const pageKey = this.$route.path + (this.$route.query.tab || '')
      if (historicHeader) {
        historicHeader[pageKey] = header
        this.$ls.set(HISTORIC_HEADER, historicHeader)
      } else {
        this.$ls.set(HISTORIC_HEADER, { [pageKey]: header })
      }

      this.selectedHeader = header
    },
    /**
     * 更新表格
    */
    updateTable (header) {
      this.isShowTable = false

      this.$nextTick(() => {
        this.updateHeader(header)
        this.isShowTable = true
      })
    },
    selecteAll () {
      this.updateHeader(this.avaliableHeader)
    },
    changePage (value) {
      this.$emit('update:currentPage', value)
      this.$emit('current-change', value)
    },
    toggleSearch () {
      this.isShowSearch = !this.isShowSearch
    },
    handleInputChange (value) {
      this.searchString = value
    },
    handleSearch () {
      const value = this.searchString
      this.isShowTable = false

      this.$nextTick(() => {
        this.$slots.default[0].componentOptions.propsData.data = this.$slots.default[0].componentInstance.data.filter((item) =>
          this.avaliableProps.some((header) => String(item[header]).includes(value))
        )
        this.isShowTable = true
      })
    },
    onSortCheckBoxChange (value) {
      if (this.sortHeader[0] !== value) {
        this.sortHeader = [value]

        this.$emit('sort', this.sortHeader, this.sortType)
      }
    },
    onSortTypeChange (value) {
      this.sortType = value

      this.$emit('sort', this.sortHeader, this.sortType)
    },
    hadnleInputClick (event) {
      event.stopPropagation()
    }
  },
  mounted () {
    this.initHeader()

    this.$slots.default[0].componentOptions.children.forEach((item) => {
      this.avaliableProps.push(item.componentOptions.propsData.prop)
      this.avaliableHeader.push(item.componentOptions.propsData.label)
    })

    document.addEventListener('click', () => {
      if (this.isShowSearch) this.isShowSearch = false
    })

    this.lastTableData = this.$slots.default[0].componentOptions.propsData.data
  },
  /**
   * FIXME:
   * 当props和slot更新的时候，render里面的 Table.componentInstance将是undefined。
   * 目前有两种情况需要进行强制更新
   *
   * props.currentPage
   * slot.default 表格的数据更新
   *
  */
  updated () {
    if (
      !Object.is(this.$slots.default[0].componentOptions.propsData.data, this.lastTableData) ||
      this.currentPage !== this.lastPage
    ) {
      this.isShowTable = false

      this.lastPage = this.currentPage
      this.lastTableData = this.$slots.default[0].componentOptions.propsData.data

      this.$nextTick(() => {
        this.isShowTable = true
      })
    }
  },
  render () {
    const { pageSize, total, currentPage } = this.$props
    const { avaliableHeader, selectedHeader, isShowTable, sortHeader, sortType } = this.$data

    const Table = this.$slots.default[0]

    if (Table.componentOptions && Table.componentInstance) {
      Table.componentOptions.children = Table.componentInstance.$slots.default.filter((item, index) => {
        return selectedHeader.includes(item.componentOptions.propsData.label)
      })
    }

    return (
      <div class="z-table">
        <div class="z-table__content">
          {isShowTable ? Table : null}
        </div>

        {
          this.isShowPagination &&
          <el-pagination
            background
            layout="prev, pager, next, total"
            page-size={pageSize}
            total={total}
            current-page={currentPage}
            vOn:current-change={this.changePage}
            class="z-table__pagination"
          />
        }

        { this.isShowPageSearch &&
          <div class="z-table__search-wrapper" onClick={this.hadnleInputClick}>
            <span class="z-table__icon" onClick={this.toggleSearch}>
              <i class="el-icon-search"></i>
            </span>

            <el-input
              value={this.searchString}
              onInput={this.handleInputChange}
              vOn:keyup_enter_native={this.handleSearch}
              placeholder="按回车在本页内搜索"
              size="medium"
              clearable
              onClear={this.handleSearch}
              class={[this.isShowSearch ? 'is-show' : 'is-hide', 'z-table__search'] }
            />
          </div>
        }

        { this.isShowSort &&
          <div class="z-table__sort-wrapper">
            <el-dropdown
              trigger="click"
            >
              <span class="z-table__icon">
                <i class="el-icon-sort"></i>
              </span>

              <el-dropdown-menu
                slot="dropdown"
                class="z-table__selection"
              >
                <div>
                按选定表头的表头进行排序
                </div>

                <el-switch
                  value={sortType}
                  active-text="升序"
                  inactive-text="降序"
                  active-value="ascending"
                  inactive-value="descending"
                  onChange={this.onSortTypeChange}
                  style="margin: 8px 0 5px;"
                />

                <el-checkbox-group value={sortHeader}>
                  {
                    avaliableHeader.map((item, index) => (
                      <el-checkbox
                        key={item}
                        label={item}
                        onChange={this.onSortCheckBoxChange.bind(this, item, index)}
                      />
                    ))
                  }
                </el-checkbox-group>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        }

        { this.isShowSelection &&
          <div class="z-table__selection-wrapper">
            <el-dropdown
              trigger="click"
            >
              <span class="z-table__icon">
                <i class="el-icon-setting"></i>
              </span>

              <el-dropdown-menu
                slot="dropdown"
                class="z-table__selection"
              >
                <div>
                自定义表头
                </div>

                <el-checkbox-group value={selectedHeader}>
                  {
                    avaliableHeader.map((item, index) => (
                      <el-checkbox
                        key={item}
                        label={item}
                        onChange={this.onCheckBoxChange.bind(this, item, index)}
                      />
                    ))
                  }
                </el-checkbox-group>

                <div>

                  <el-button onClick={this.selecteAll} type="primary" plain round size="mini">全选</el-button>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        }

      </div>
    )
  }
}
</script>

<style lang="scss" scoped>
.z-table {
  margin: 15px 0;
  position: relative;
}
.z-table__search-wrapper {
  display: inline-block;
  position: absolute;
  right: 86px;
  top: -33px;
  margin: 15px 0;

  border-radius: 10px;

  .z-table__search {
    margin: 0;
    width: 0;
    transition: width 0.3s, margin 0.3s;
  }
  .is-show {
    margin: 0 5px;
    width: 200px;
  }
}
.z-table__sort-wrapper {
  position: absolute;
  right: 46px;
  top: -33px;
  margin: 15px 0;
}
.z-table__selection-wrapper {
  position: absolute;
  right: 6px;
  top: -33px;
  margin: 15px 0;
}
.z-table__icon {
  display: inline-block;
  width: 38px;
  height: 38px;
  line-height: 38px;
  text-align: center;

  font-size: 18px;
  color: #fff;

  border-radius: 50%;

  background-color: #1890ff;

  cursor: pointer;
}
.z-table__selection {
  padding: 10px;

  background: #fff;

  .el-checkbox-group {
    margin-bottom: 8px;
    width: 185px;
    max-height: 300px;
    overflow: auto;

    border-bottom: 1px solid #e8e8e8;
  }
  .el-checkbox {
    display: block;
    margin: 8px 0;
  }
}
.z-table__content {
  min-height: 200px;
}
.z-table__pagination {
  margin-top: 15px;
  text-align: right;
}
</style>

<style lang="scss">
.z-table__search-wrapper {
  .is-hide {
    .el-input__inner {
      padding: 0;
      border: none;
    }
  }
}
</style>
